import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'

import router from './router'
import store from './store'


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';

// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';
axios.defaults.baseURL = 'https://mysoftcodeadmin.mysoftcode.com/api';



createApp(App).use(store).use(router).mount('#app')
